<template>
  <div class="body" :style="backgroundDiv">
    <div class="container" style="max-width:1000px; margin: 0 auto;">
      <div>
        <img v-if="eventsImage.LogoImg != ''" :src="'./file/image/'+$route.query.peid+'/LogoImg.png'" alt="">
        <img v-else :src="require('../assets/hongbao/logo/defult.png')" alt="" width="100%">
        <img v-if="eventsImage.TitleImg != ''" :src="'./file/image/' + $route.query.peid + '/TitleImg.png'" alt="">
        <img v-else :src="require('../assets/hongbao/logo/defult.png')" alt="" width="100%">
        <!-- <img src="img/logo.png" alt="" class="logo_s" style=" "> -->
      </div>
      <div style="text-align: center;color: #fff;" class="time_to">
        <h2 style="color:#FFDB6D;font-style:italic ">{{ $t('turn.EventsTime')}}</h2>
        <div style="display: flex;justify-content: center;  align-items: center;">
          <div style="padding: 4px;">
            <h4>{{ startTime[0] }}</h4>
            <h4 style="color:#FFECBB;">{{ startTime[1] }}</h4>
          </div>
          <div>
            <h4 style="color:#FFDB6D;" class="to01">{{ $t('turn.to')}}</h4>
          </div>
          <div style="padding: 4px;">
            <h4> {{ endTime[0] }}</h4>
              <h4 style="color:#FFECBB">{{ endTime[1] }}</h4>
          </div>
        </div>
        <img src="../assets/hongbao/img/hr.png" alt="" width="100%">
        <img v-if="eventsImage.DirectionsImg != ''" :src="'./file/image/' + $route.query.peid + '/DirectionsImg.png'" alt="">
        <img v-else :src="require('../assets/hongbao/text/defult.png')" alt="" width="100%">

      </div>
        <div>
          <div class="row align-items-md-stretch">
            <div class="col-md-12">
              <div class="row">
                <div>
                  <div class="container text-center" style="color: #FFECBB;text-shadow: 0.1em 0.1em #333;">
                    <div class="row">

                      <div class="col-md-6">
                        <h3 class="mt-2">{{$t('turn.account')}}： <span>{{ this.userInformationData.user }}</span> </h3>
                      </div>
                      <div class="col-md-6">
                        <h3 class="mt-2">{{$t('turn.count')}}： <span>{{ this.count }}</span> </h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                </div>
              </div>
            </div>
            <div class="col-md-12">
                  <div class="lucky_bag">
                    <img v-if="eventsImage.PrizeImg != ''" :src="'./file/image/' + $route.query.peid + '/PrizeImg.png'" alt="">
                    <img v-else :src="require('../assets/hongbao/prize/defult.png')" alt="" width="100%">

                    <img :src="require('../assets/hongbao/img/button01' + lang+'.png')" alt="" class="lucky_btn"
                            data-bs-toggle="modal" data-bs-target="#exampleModalToggle" @click="onCheck">
                  </div>

            <div class="modal fade" id="threeHongbaoModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                          <div class="modal-header">
                          </div>
                          <div class="modal-body">

                            <div>
                              <!-- <img src="../assets/hongbao/img/modal_bgtw.png" alt="" style="width: 100%; "> -->
                              <img :src="require('../assets/hongbao/img/modal_bg'+lang+'.png')" alt="" style="width: 100%; ">
                              <div class="envelope_cover">
                                <img :src="require('../assets/hongbao/img/envelope01' + lang +'.png')" alt="" data-bs-target="#exampleModalToggle2" @click="chooseHongbao" data-bs-toggle="modal"
                                  class="envelope01">
                                <img :src="require('../assets/hongbao/img/envelope02' + lang +'.png')" alt="" data-bs-target="#exampleModalToggle2" @click="chooseHongbao" data-bs-toggle="modal"
                                  class="envelope01">
                                <img :src="require('../assets/hongbao/img/envelope03' + lang +'.png')" alt="" data-bs-target="#exampleModalToggle2" @click="chooseHongbao" data-bs-toggle="modal"
                                  class="envelope01">
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal fade" id="winHongbaoModal" aria-hidden="true" aria-labelledby="exampleModalToggleLabel2"
                      tabindex="-1">
                      <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                          <div class="modal-header">
                          </div>
                          <div class="modal-body">
                            <div class="money_cover">

                              <div class="money_text" style="color: #a00512;">
                                <p> {{msg}}</p>
                                <span class="money_text2">{{msg2}}</span>
                              </div>
                            </div>
                            <img :src="require('../assets/hongbao/img/comfirm' + lang +'.png')" alt="" width="100%" class="comfirm_btn" @click="closeWinHongbao">
                          </div>
                        </div>
                      </div>
                    </div>


                  <table class="table table-bordered text-center"
                    style="border-radius: 20px;line-height: 1.5;background: linear-gradient(to bottom, #FFF4C8,#FCDE7C,#FFFAEE, #FFE979,#603515,#9F6F1D,#DCC35E); border: 5px solid #322fd000;">
                      <thead class="striped-tit">
                        <tr class="text-white" style="font-weight: bold;">
                          <th scope="col">{{ $t('winningRecord.winningTime')}}</th>
                          <th scope="col">{{ $t('winningRecord.award')}}</th>
                          <th scope="col">{{ $t('winningRecord.status')}}</th>
                        </tr>
                      </thead>
                  <tbody>
                    <tr class="striped-1" v-for="data in winningData" :key="data.id">
                      <th scope="row">{{data.drawTime}}</th>
                      <td>{{data.award}}</td>
                      <td :style="activation(data.status)">{{data.status}}</td>
                    </tr>
                  </tbody>
                </table>
              <div style="text-align: center;">
                <button type="button" class="btn btn-secondary" style="color: #fff;" v-if="currentPage > 1"
                  @click="nextPage(-1)">{{ $t('winningRecord.previousPage')}}</button>
                <span style="color: #fff;">{{ $t('winningRecord.page', { page: currentPage })}}</span>
                <button type="button" class="btn btn-secondary" style="color: #fff;" v-if="nextPageVisable"
                  @click="nextPage(1)">{{ $t('winningRecord.nextPage')}}</button>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="text-center m-3">
            <div class="row">

              <div class="col" style="max-width:1000px;margin: 0 auto;">
                <img v-for="logo in footerlogo"  v-bind:key="logo" :src="'./file/image/' + $route.query.p + '/' + logo + '.png'" class="col-2" width="100%" />
              </div>
            </div>
          </div>
          <div class="ui-gotop">
            <a :href=backUrl>
              <img src="../assets/hongbao/img/home.svg" width="30px"></a>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui';
import modal from "bootstrap/js/dist/modal";

export default {
  data() {
    return {
      backgroundDiv: {
        backgroundImage: 'url(' + require('../assets/hongbao/img/1920.png') +')'//背景圖
      },
      userInformationData: {
        user: "",
        token: "",
        platform: "",
        peid: ""
      },
      backUrl:"",
      startTime: [],
      endTime: [],
      eventsStime: "",
      eventsEtime:"",
      eventsImage: [],
      show: false,
      msg: "",
      msg2: "",
      active: false,
      winningData: [],
      awardsListForm: [],
      count: null,
      nextPageVisable: false,
      currentPage:1,
      total: 0,
      page_size: 10,
      unlock: true,
      threeHongbaoModal: "",
      wingHongbaoModal: "",
      lang: "zh-tw",
      rolling: false,
      footerlogo: []
    };
  },
  mounted() {
    this.getEventsTime(this.$route.query.peid)
    this.checkUserToken(this.$route.query.user, this.$route.query.token, this.$route.query.p, this.$route.query.peid)
    this.getAwardsList()
    this.getMemberReport()
    this.getWinningRecord(1)
    // this.getEvents()
    this.threeHongbaoModal = new modal(document.getElementById("threeHongbaoModal"));
    this.winHongbaoModal = new modal(document.getElementById("winHongbaoModal"));
  },
  computed: {
    activation() {
      return (istatus) => {
        if (istatus == this.$t('turn.payed')) {
          return { 'color': 'red' }
        }
      }
    }
  },
  methods: {
    async onCheck() {
      const dateTime = Date.now();
      const timestamp = Math.floor(dateTime / 1000);
      const now = this.formatDate(timestamp)

      if (now < this.eventsStime) {
        this.msg = this.$t('turn.EventsNotStart')
        this.msg2 = this.$t('turn.StartlookIt')
        this.winHongbaoModal.show();
      }else{
        if (this.eventsEtime < now) {
          this.msg = this.$t('turn.EventsisEnd')
          this.msg2 = this.$t('turn.ThanksJoin')
          this.winHongbaoModal.show();
        } else {
          let postData = {
            PEid: this.$route.query.peid,
            User: this.$route.query.user
          }
          await fetch('/api/checkUser',
            { method: "POST", body: JSON.stringify(postData) }).then(res => res.json()).then(res => {
              if (res.data == "0") {
                this.msg = this.$t('turn.accountError')
                this.msg2 = this.$t('turn.contact')
                this.winHongbaoModal.show();
              } else {
                this.threeHongbaoModal.show();
              }
            })
        }
      }
    },
    chooseHongbao() {
      //如果次數為0 不得抽獎
      if (this.count === 0 || this.count === null) {
        this.threeHongbaoModal.hide();
        this.winHongbaoModal.show();
        this.msg = this.$t('turn.zero')
        this.msg2 = ""
        // 如果尚在抽獎中不執行任何動作
      } else {
        if (this.rolling) {
          this.threeHongbaoModal.hide();
          this.winHongbaoModal.show();
          this.msg = this.$t('turn.drawing')
          this.msg2 = ""
          return;
        }
        this.getWinning()
      }
    },
    closeWinHongbao() {
      this.winHongbaoModal.hide();
    },
    getEventsTime(peid){
      let postData = {
        PEid: peid
      }
      fetch('/api/getEventsTime',
        { method: "POST", body: JSON.stringify(postData) }).then(res => res.json()).then(res => {
          this.lang = res.data.Lang
          this.$i18n.locale = this.lang
          this.backUrl = res.data.BackUrl
          this.eventsStime = res.data.StartTime.substr(0,19)
          this.eventsEtime = res.data.EndTime.substr(0, 19)
          this.footerlogo = JSON.parse(res.data.Footerlogo)
          let st = ""
          let et = ""
          this.startTime = res.data.StartTime.split(' ')
          this.endTime = res.data.EndTime.split(' ')
          if (this.lang == "zh-tw") {
            st = this.startTime[0].substring(0, 4) + "年" + this.startTime[0].substring(5, 7) + "月" + this.startTime[0].substring(8, 10) + "日"
            et = this.endTime[0].substring(0, 4) + "年" + this.endTime[0].substring(5, 7) + "月" + this.endTime[0].substring(8, 10) + "日"
          }else{
            let sdate = new Date(this.eventsStime)
            let enSDate = sdate.toDateString()
            let enStartDateArray = enSDate.split(' ')
            st = `${enStartDateArray[1]} ${enStartDateArray[2]}, ${enStartDateArray[3]}`
            let edate = new Date(this.eventsEtime)
            let enEDate = edate.toDateString()
            let enEndDateArray = enEDate.split(' ')
            et = `${enEndDateArray[1]} ${enEndDateArray[2]}, ${enEndDateArray[3]}`
          }
          this.startTime[0] = st
          this.endTime[0] = et
        })
      this.getPlatformEventsImageByid(postData)
    },
    getPlatformEventsImageByid(postData) {
      fetch('/api/getPlatformEventsImageByid',
        { method: "POST", body: JSON.stringify(postData) }).then(res => res.json()).then(res => {
          if (res.code == 200) {
            this.eventsImage = res.data[0]
          }
        })
    },
    async getAwardsList() {
      let postData = {
        PEid: this.userInformationData.peid
      }
      await fetch('/api/getEventsAwardsList',
        { method: "POST", body: JSON.stringify(postData) }).then(res => res.json()).then(res => {
          for (var i = 0; i < res.data.length; i++) {
            this.awardsListForm[i] = res.data[i].prizeName
          }
        })
    },
    async getWinning() {
      this.rolling = true;
      let postData = {
        User: this.userInformationData.user,
        Token: this.userInformationData.token,
        Platform: this.userInformationData.platform,
        PEid: this.userInformationData.peid
      }
      await fetch('/api/drawEvents',
        { method: "POST", body: JSON.stringify(postData) }).then(res => res.json()).then(res => {
          if (res.code == "0") {
            this.roll(res.data);
          } else {
            this.$message.error(this.$t('turn.' + res.data));
            this.rolling = false;
          }
        })
    },
    roll(result) {
      if (isNaN(result)){
        let jresult = JSON.parse(result)
        let result_name = Object.keys(jresult)
        result = result_name[0]
      }
      setTimeout(() => {

        this.threeHongbaoModal.hide();
        this.winHongbaoModal.show();
        this.msg = this.$t('turn.congratulations');
        this.msg2 = this.awardsListForm[result]


        this.rolling = false;
        this.count = this.count - 1

        this.list = this.list + 1
        this.button_disabled = false
        this.currentPage = 1
        this.getWinningRecord(this.currentPage)
      }, 200);

    },
    checkUserToken(user, token, platform, peid) {
      this.userInformationData.user = user
      this.userInformationData.token = token
      this.userInformationData.platform = platform
      this.userInformationData.peid = peid
    },
    async getWinningRecord(page) {
      let loadingInstance = Loading.service({ background: 'rgba(0, 0, 0, 0.6)' });
      this.dialogTableVisible = true
      let postData = {
        User: this.userInformationData.user,
        Token: this.userInformationData.token,
        PEid: this.userInformationData.peid,
        Platform: this.userInformationData.platform,
        pageNum: page - 1
      }
      await fetch('/api/getEventsWinning',
        { method: "POST", body: JSON.stringify(postData) }).then(res => res.json()).then(res => {
          if (res.data.length > 0 && res.code == '0') {
            for (let index = 0; index < res.data.length; index++) {
              res.data[index].drawTime = this.formatDate(res.data[index].drawTime)
              // res.data[index].award = this.$t('awards.' + res.data[index].award)
              res.data[index].award = this.awardsListForm[res.data[index].award]
              if (res.data[index].status == "0") {
                res.data[index].status = this.$t('turn.unpay')
              } else {
                res.data[index].status = this.$t('turn.payed')
              }
            }
            this.total = res.total
            let total_count = this.total / (page * 10)
            if (total_count > 1) {
              this.nextPageVisable = true
            } else {
              this.nextPageVisable = false
            }
            this.winningData = res.data
          }
          loadingInstance.close();
        })
    },
    nextPage(number) {
      this.currentPage = this.currentPage + number
      this.getWinningRecord(this.currentPage)
    },
    async getMemberReport() {
      let loadingInstance = Loading.service({ background: 'rgba(0, 0, 0, 0.6)' });
      let postData = {
        User: this.userInformationData.user,
        Token: this.userInformationData.token,
        Platform: this.userInformationData.platform,
        PEid: this.userInformationData.peid
      }
      await fetch('/api/getUserInfo',
        { method: "POST", body: JSON.stringify(postData) }).then(res => res.json()).then(res => {
          if (res.code == "0") {
            if (res.data) {
              this.count = Math.floor(res.data.count)
            }
          } else if (res.code == "1") {//活動未開始
            this.show = true
            this.active = true
            let arr = res.msg.split(' ');
            this.msg = res.data + this.$t('turn.' + arr[0])
            this.msg2 = this.$t('turn.' + arr[1])
            this.unlock = false
            this.count = 0
          } else if (res.code == "2") {//活動已結束
            this.show = true
            this.active = true
            let arr = res.msg.split(' ');
            this.msg = this.$t('turn.' + arr[0])
            this.msg2 = this.$t('turn.' + arr[1])
            this.unlock = false
            this.count = 0
          } else {
            this.$message.error(this.$t('turn.' + res.data) + this.$t('turn.contact'));
            this.count = 0
            this.unlock = false
            this.count = 0
          }
          loadingInstance.close();
        })
    },
    formatDate(value) {
      value = parseInt(value) * 1000
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    }
  }
}
</script>


<style scoped>

@import '../assets/hongbao/css/style.css';
@import '../assets/hongbao/css/animate.css';
@import '../assets/hongbao/css/bootstrap.css';
</style>



// WEBPACK FOOTER //
// src/components/hongbao.vue